module.exports = __webpack_public_path__ + "static/media/hometown.7530d3f6.svg";